import ApiService from "./ApiService";

// Every sign-in form shows the failure inline (useAuth returns the message), so no toast as well.
export async function apiSignIn(data) {
  return ApiService.fetchData({
    url: `/sign-in`,
    method: "post",
    data,
    suppressErrorToast: true,
  });
}

function getReferralCode() {
  const urlRef = new URLSearchParams(window.location.search).get("ref");
  return urlRef || localStorage.getItem("tsv_ref_code");
}

export async function apiSignUp(data, alert) {
  const referralCode = getReferralCode();
  if (referralCode) {
    data.referralCode = referralCode;
  }
  return ApiService.fetchData(
    {
      url: "/sign-up",
      method: "post",
      data,
    },
    alert
  );
}

export async function apiGoogleSignUp(data, alert) {
  const referralCode = getReferralCode();
  if (referralCode) {
    data.referralCode = referralCode;
  }
  return ApiService.fetchData(
    {
      url: "/google-signup",
      method: "post",
      data,
    },
    alert
  );
}

export async function apiGoogleSignIn(data, alert) {
  return ApiService.fetchData(
    {
      url: "/google-signin",
      method: "post",
      data,
    },
    alert
  );
}

export async function apiSignOut(data, alert) {
  localStorage.removeItem("token");
  /*return ApiService.fetchData({
        url: '/sign-out',
        method: 'post',
        data
    })*/
}

export async function apiForgotPassword(data, alert) {
  return ApiService.fetchData(
    {
      url: `/password/forgot?emailAddress=` + data.emailAddress,
      method: "post",
      data,
    },
    alert
  );
}

// Body only, never the query string: there the password lands in server and proxy logs, and a
// "+", "&", "#" or "%" in it reaches the API changed.
export async function apiResetPassword({ token, password }, alert) {
  return ApiService.fetchData(
    {
      url: "/password/reset",
      method: "post",
      data: { token, password },
    },
    alert
  );
}

export async function apiUnsubscribe(data, alert) {
  return ApiService.fetchData(
    {
      url: "/public/unsubscribe",
      method: "post",
      data,
    },
    alert
  );
}

export async function apiGetTenantConfigs(params) {
  return ApiService.fetchData({
    url: "/tenant-configs",
    method: "get",
    // params,
  });
}

export async function apiSendOtp(data) {
  return ApiService.fetchData({
    url: "/user/otp",
    method: "post",
    data,
  });
}

export async function apiVerifyOtp(data) {
  return ApiService.fetchData({
    url: "user/otp/verify",
    method: "post",
    data,
  });
}
